import firebase from "firebase/compat/app";

const setUserCompatitionInfo = async function(competitionId, userId, item) {
  let db = firebase.firestore();
  let result;
  if (competitionId != undefined && userId != undefined ) {
    result = await db
      .collection("wellness_competition")
      .doc(competitionId)
      .collection("users")
      .doc(userId)
      .set(item, { merge: true });
  }
  return result;
};

export default setUserCompatitionInfo;
